import { useTranslation } from 'next-i18next';
import { useViewport } from '@/hooks';
import { SuccessToast } from '@/shared/components';
import { CLASSROOM_ROUTES } from '@/shared/constants/routes';
import { type ContentShareType } from '../types';
import { openClassroomTab } from '../utils';
export function ClassroomContentLinkedToast({
  classroomId,
  contentType,
  classroomPath,
  showGoToClassroomButton = true
}: {
  classroomId: string;
  contentType: ContentShareType;
  classroomPath?: (href: string) => string;
  /** 클래스 내부에서 연결할 땐 이미 그 클래스라 "클래스로 이동" 버튼이 불필요 → false. */
  showGoToClassroomButton?: boolean;
}) {
  const {
    t
  } = useTranslation(['common']);
  const {
    isMobile
  } = useViewport();
  const linkedMessage = contentType === 'QUIZSET' ? t('common:classroomLink.quizLinkedMessage') : t('common:classroomLink.boardLinkedMessage');
  const classroomHref = classroomPath?.(CLASSROOM_ROUTES.detail(classroomId, true, {
    isMobile
  }));
  return <SuccessToast message={linkedMessage} action={showGoToClassroomButton && classroomHref ? {
    label: t('common:classroomLink.goToClassroomButton'),
    onClick: () => openClassroomTab(classroomHref)
  } : undefined} data-sentry-element="SuccessToast" data-sentry-component="ClassroomContentLinkedToast" data-sentry-source-file="ClassroomContentLinkedToast.tsx" />;
}